<template>
    <div>
        <hourly-annual-leave-report-list></hourly-annual-leave-report-list>
    </div>
    </template>
    <script>
    export default {}
    </script>
    